import { useQuery } from '@tanstack/react-query';
import getAccountLivestream from 'Api/live-account/getLiveAccount';
import getParentAccountRequest from './model/request/getParentAccountRequest';
import getParentAccountResponse from './model/response/getParentAccountResponse';

const useGetParentAccount = (queryParams) => {
  return useQuery({
    queryKey: ['parent-account', queryParams?.brand?.value],
    queryFn: async () => {
      const queries = getParentAccountRequest(queryParams);

      const response = await getAccountLivestream(queries);

      const result = getParentAccountResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 15 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    enabled: !!queryParams?.brand,
  });
};

export default useGetParentAccount;
